export const HOME = { label: 'Home', url: '/' };

// Paths
export const SEARCH_ORDER = '/payment-search/order';

export const searchOrder = [
  HOME,
  { label: 'Search Order', url: '/payment-search/order' },
];
